const MOST_POPULAR_TITLE = "Most Popular";
const normalizeTitle = (s: string) => s.trim().toLowerCase();
export const isMostPopularTitle = (s: string) =>
  normalizeTitle(s) === normalizeTitle(MOST_POPULAR_TITLE);
